import BlogImage from "../../../../src/components/BlogComponents/BlogImage";
import * as React from 'react';
export default {
  BlogImage,
  React
};